export default [
  {
    name: 'Hobbies',
    tags: [
      'Cycling',
      'Swimming',
      'Blogging',
      'Vlogging',
      'Hiking',
      'Gaming',
      'Partying',
      'Photography',
      'Volunteering',
      'Cards',
      'Theater',
      'Painting',
      'Cooking',
      'Gardening',
      'Traveling',
      'Guitar',
      'Piano',
      'Board Games',
      'Knitting',
      'Yoga',
      'Birdwatching',
      'Woodworking',
      'Martial Arts',
      'Podcasting',
      'Dancing',
      'Rock Climbing',
      'Origami',
      'Parkour',
      'Chess',
      '3D Printing',
      'Fitness',
      'Calligraphy',
      'Journaling',
      'Surfing',
      'Ice Skating',
      'Archery',
      'Beekeeping',
      'Sailing',
      'Tarot Reading',
      'Cosplay',
      'Manga and Anime',
      'Martial Arts',
      'Astronomy',
      'Recycling',
      'Pottery',
      'Mountain biking',
      'Snowboarding',
      'Skiing',
      'Fishing',
      'Camping',
      'Puzzle solving',
      'Trivia',
      'Learning new languages',
      'Skateboarding',
      'Rollerblading',
      'Bungee jumping',
      'Grafitti art',
      'Tatto design',
      'Canlde making',
      'Carving (wood/stone)',
      'Kayaking',
      'Home brewing',
      'Pole dancing',
      'Stamp collecting',
    ],
  },
  {
    name: 'Career',
    tags: [
      'Unemployed',
      'Dentist',
      'Librarian',
      'Designer',
      'Stylist',
      'Scientist',
      'Writer',
      'Teacher',
      'Student',
      'Firefighter',
      'Lawyer',
      'Engineer',
      'Architect',
      'Doctor',
      'Nurse',
      'Pilot',
      'Captain',
      'Chef',
      'Software developer',
      'Accountant',
      'Police officer',
      'Photographer',
      'Entrepreneur',
      'Veterinarian',
      'Psychologist',
      'Pharmacist',
      'Mechanic',
      'Biologist',
      'Journalist',
      'Social worker',
      'Financial analyst',
      'Artist',
      'Bank Teller',
      'Electrician',
      'Astronomer',
      'Astronaut',
      'Scuba Diver',
      'Swimmer',
      'Pharmacist',
      'Baker',
      'Florist',
      'Soldier',
      'Life Coach',
      'Secretary',
      'Spy',
      'Chemist',
      'Mathematician',
      'Kickboxer',
      'Escort',
      'Flight attendant',
      'Dancer',
      'Daytrader',
      'Game developer',
      'Dean',
      'Streamer',
      'Social media influencer',
      'Bartender',
      'Carpenter',
      'Makeup artist',
      'Voice actor',
      'Event planner',
      'Tour guide',
      'Gym trainer',
      'Plumber',
      'Real estate investor',
      'E-sports player',
      'Football player',
      'Basketball player',
      'Rugby player',
      'Data scientist',
      'Graphic designer',
      'Scrum master',
      'CFO',
    ],
  },
  {
    name: 'Personality',
    tags: [
      'Submissive',
      'Shy',
      'Dominant',
      'Mean',
      'Nympho',
      'Cynical',
      'Naive',
      'Wise',
      'Rebellious',
      'Mysterious',
      'Intellectual',
      'Adventurous',
      'Evil',
      'Cocky',
      'Optimistic',
      'Pessimistic',
      'Argumentative',
      'Loyal',
      'Disloyal',
      'Religious',
      'Flirty',
      'Nostalgic',
      'Nympho',
      'Carefree',
      'Perfectionist',
      'Detatched',
      'Teasing',
      'Persuasive',
      'Skeptical',
      'Emotional',
      'Grumpy',
      'Eccentric',
      'Friendly',
      'Confident',
      'Superstitious',
      'Stingy',
      'Generous',
      'Dumb',
      'Jealous',
      'Bipolar',
      'Indecisive',
      'Sarcastic',
      'Serious',
      'Complainer',
      'Whiner',
      'Funny',
      'Responsible',
      'Irresponsible',
      'Minimalist',
      'Hedonist',
      'Abuser',
      'Manipulator',
      'Gaslighter',
    ],
  },
  {
    name: 'Relationship',
    tags: [
      'Stranger',
      'Friend',
      'Friend with benefits',
      'Best friend',
      'Work colleague',
      'Mentor',
      'Pen pal',
      'Mentee',
      'Teacher',
      'Student',
      'Roommate',
      'Crush',
      'Boss',
      'Employee',
    ],
    optionsFemale: [
      'Girlfriend',
      'Ex-girlfriend',
      'Wife',
      'Ex-wife',
      'Mistress',
      'Stepsister',
      'Stepmom',
      'Stepdaughter',
      'fiancée',
    ],
    optionsMale: [
      'Boyfriend',
      'Ex-boyfriend',
      'Husband',
      'Ex-husband',
      'Stepbrother',
      'Stepdad',
      'Stepson',
      'fiancé',
    ],
  },
  {
    name: 'Family',
    tags: [
      'Separated parents',
      'Fatherless',
      'Adopted',
      'Foster care',
      'Only child',
      'Two-father household',
      'Two-mother household',
      'Traditional household',
      'In shared custody',
    ],
  },
  {
    name: 'Financials',
    tags: [
      'Has trust fund',
      'Upper class',
      'Middle class',
      'Working class',
      'Bankrupt',
    ],
  },
  {
    name: 'Texting Style',
    tags: [
      'Moderate emoji use',
      'Excessive emoji use',
      'Excessive punctuation use',
      'All caps',
      'All lowercase',
      'Detailed',
      'Straight to the point',
      'Broken English',
      'Formal tone',
      'Excessive slang use',
    ],
  },
  {
    name: 'Misc',
    tags: [
      'Homeless',
      'Believes in aliens',
      'Vegan',
      'Tech geek',
      'Polyglot',
      'Conspiracy Theorist',
      'Night owl',
      'Early bird',
      'Environmentalist',
      'Afraid of heights',
      'Adrenaline junkie',
      'Hoarder',
      'Coffee addict',
      'Locked up in jail',
      'Nomad',
    ],
  },
  {
    name: 'Fetishes',
    tags: [
      'Homosexual',
      'Bisexual',
      'Asexual',
      'Feet',
      'Bondage',
      'ASMR',
      'Smoking',
      'Cuckolding',
      'Tease/denial',
      'Anilingus',
      'Blindfolding',
      'Anal',
      'Sex in public',
      'Gagging',
      'Humiliation',
      'Golden shower',
      'Sploshing',
      'Financial domination',
      'Tickling',
    ],
  },
]
